import { User } from '@/portainer/users/types';
import { Team } from '@/react/portainer/users/teams/types';
import { RbacRole } from '@/react/portainer/users/RolesView/types';

import { NamespaceAccess, NamespaceAccesses } from './types';

export function parseNamespaceAccessPolicy(
  data: NamespaceAccesses | null | undefined,
  users: User[],
  teams: Team[],
  roles?: RbacRole[]
): NamespaceAccess[] {
  if (!data) {
    return [];
  }

  const userAccesses = Object.entries(data.UserAccessPolicies || {}).flatMap(
    ([userId, policy]) => {
      const user = users.find((u) => u.Id === parseInt(userId, 10));
      if (!user) {
        return [];
      }

      const roleId = (policy as { RoleId: number }).RoleId;
      const role = roles?.find((r) => r.Id === roleId);

      return [
        {
          id: user.Id,
          name: user.Username,
          type: 'user' as const,
          role: role
            ? { id: role.Id, name: role.Name }
            : { id: roleId, name: '' },
        },
      ];
    }
  );

  const teamAccesses = Object.entries(data.TeamAccessPolicies || {}).flatMap(
    ([teamId, policy]) => {
      const team = teams.find((t) => t.Id === parseInt(teamId, 10));
      if (!team) {
        return [];
      }

      const roleId = (policy as { RoleId: number }).RoleId;
      const role = roles?.find((r) => r.Id === roleId);

      return [
        {
          id: team.Id,
          name: team.Name,
          type: 'team' as const,
          role: role
            ? { id: role.Id, name: role.Name }
            : { id: roleId, name: '' },
        },
      ];
    }
  );

  return [...userAccesses, ...teamAccesses];
}
